<template>
    <div>
        <el-form  :inline="true" :model="search">
            <el-form-item label="商品编号">
                <el-input style="width: 140px" v-model="search.number" placeholder="输入商品编号" />
            </el-form-item>
            <el-form-item label="商品名称">
                <el-input style="width: 140px" v-model="search.name" placeholder="输入商品名称" />
            </el-form-item>
            <el-form-item label="商品分类">
                <el-select
                    style="width: 140px"
                    ref="selectReport"
                    v-model="search.categoryName"
                    placeholder="商品分类"
                >
                    <el-option
                        :value="search.category"
                        :label="search.categoryName"
                        style="
                            width: 100%;
                            height: 200px;
                            overflow: auto;
                            background-color: #fff;
                        "
                    >
                        <el-tree
                            :data="all"
                            default-expand-all
                            :expand-on-click-node="false"
                            @node-click="handleNodeClick"
                        />
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchData()"
                ></el-button>
            </el-form-item>
            <el-button style="float: right;" type="primary" @click="selectBox=!selectBox">{{selectBox?"收起":"查看"}}</el-button>
        </el-form>
        <div style="display:flex;width:100%">
            <el-table
                ref="multipleTable"
                v-loading="listLoading"
                :data="list"
                border
                fit
                highlight-current-row
                :max-height="400"
            >
                <template v-for="(col, index) in cols">
                    <el-table-column
                        v-if="col.show"
                        :key="index"
                        :align="col.align"
                        :label="col.label"
                        :width="col.width"
                        :min-width="col.min_width"
                    >
                        <template slot-scope="{ row }">
                            <template v-if="col.edit">
                                <template v-if="col.type === 'table'">
                                    <div v-if='row.specs.length>1'>
                                        <el-button type="primary" @click="openDialog(row,2)">列</el-button>
                                        <el-button type="primary" @click="openDialog(row,1)">横列</el-button>
                                        <el-button type="primary" @click="openDialog(row,3)">复选</el-button>
                                    </div>
                                    <div v-else>
                                        <InNumber
                                            :datainfo="row.specs[0]"
                                            :dataKey="'count'"
                                            v-if="$global.buyType!=2"
                                            :comWidth='180'
                                            :suffix="$global.pack"
                                            @changeEnd="changeEnd($event,row,row.specs[0],'count')"
                                        ></InNumber>
                                        <div style="height:5px" v-if="$global.buyType==0"></div>
                                        <InNumber
                                            :datainfo="row.specs[0]"
                                            :dataKey="'num'"
                                            v-if="$global.buyType!=1"
                                            :comWidth='180'
                                            :suffix="$global.unit"
                                            @changeEnd="changeEnd($event,row,row.specs[0],'num')"
                                        ></InNumber>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="col.type === 'image'">
                                    <el-image
                                        v-if="row[col.prop].length > 0"
                                        style="width: 40px"
                                        :src="row[col.prop][0]"
                                        :preview-src-list="row[col.prop]"
                                        @click.stop="cancelRow"
                                    />
                                    <div v-else class="errorFonts_mini" style="width: 40px;height:40px;line-height:20px;margin-left:10px">暂无图片</div>
                                </template>
                                <template v-else>
                                    <span>{{ row[col.prop] }}</span>
                                </template>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div style="width:300px" v-show="selectBox">
                <el-table
                    :data="selectData"
                    border
                    fit
                    
                    highlight-current-row
                    :max-height="300"
                >
                    <el-table-column type="expand" width="100px">
                        <template slot-scope="props">
                            <el-row v-for="sp in props.row.specs" :key="sp.id" v-show="sp.num>0||sp.count>0">
                                <el-col :span="10">
                                    <span class="proInfo">{{sp.color?(sp.color+"-"+sp.size):"标准"}}</span>
                                </el-col>
                                <el-col :span="14">
                                    <span class="proInfo" v-if="$global.buyType==0">{{sp.count+$global.pack+sp.num+$global.unit}}</span>
                                    <span class="proInfo" v-else-if="$global.buyType==1">{{sp.count+$global.pack}}</span>
                                    <span class="proInfo" v-else>{{sp.num+$global.unit}}</span>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="商品" align="left">
                    </el-table-column>
                </el-table>
            </div>
            
        </div>
        <el-pagination
            style="margin-top: 15px;text-align: right;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="search.limit"
            layout="total, sizes, prev, pager, next"
            :total="search.total"
            :pager-count="5"
        />
        <el-dialog :visible.sync="specsDialog" title="列添加" width="60%" v-if="specsDialog" append-to-body>
            <div style="margin-bottom:22px">
                <el-button type="danger" @click="clearAll()">清空</el-button>
                <el-button type="warning" @click="specsDialog = false">关闭</el-button>
            </div>
            <Specs :tableData="tableData" @checkSpNumber="checkSpNumber" :addModel="addModel"></Specs>
        </el-dialog>
        <el-dialog :visible.sync="MutiDialog" title="复选添加" width="60%" append-to-body>
            <MutiCheck :tableData="tableData" @checkSpNumber='checkSpNumber' @close="close"></MutiCheck>
        </el-dialog>
    </div>
    
</template>

<script>
import Specs from './specs.vue';
import MutiCheck from './muticheck.vue';
export default {
    components:{Specs,MutiCheck},
    props: {
        cid:{
            type:Number,
            default:0,
        }
    },
    data() {
        return {
            imgProfit: this.$api.baseURL,
            search: {
                number: "",
                name: "",
                category: "",
                categoryName: "",
                limit: 20,
                total: 1,
                page: 1,
                valid:1,
            },
            tableData:[],
            list: [],
            cols: [
                {
                    prop: "number",
                    label: "编号",
                    show: true,
                    width: 80,
                },
                {
                    prop: "name",
                    label: "商品名称",
                    show: true,
                    min_width: 150,
                },
                {
                    prop: "image",
                    label: "商品图片",
                    show: true,
                    align:"center",
                    type: "image",
                    width: 80,
                },
                {
                    prop: "num",
                    label: "数量",
                    align:'left',
                    show: true,
                    edit: true,
                    type: "table",
                    width: 250,
                },
                {
                    prop: "year",
                    label: "开发年度",
                    show: true,
                    width: 100,
                },
                // {
                //     prop: "categorys",
                //     label: "商品分类",
                //     show: true,
                //     width: 100,
                // },
                {
                    prop: "label",
                    label: "商品标签",
                    show: true,
                    min_width: 100,
                },
                {
                    prop: "code",
                    label: "商品条码",
                    show: true,
                    min_width: 100,
                },
                {
                    prop: "unit",
                    label: "单位数量",
                    show: true,
                    width: 100,
                },
                // {
                //     prop: "price",
                //     label: "单价(元)",
                //     show: true,
                //     width: 80,
                // },
                // {
                //     prop: "remark",
                //     label: "备注",
                //     width:120,
                //     show: true,
                // },
            ],
            listLoading: false,
            all: [],
            specsDialog:false,
            MutiDialog:false,
            selectBox:false,
            selectData:[],
            searchObj:{
                page:1,
                limit:20,
                cid:this.cid,
                valid:1,
            },
            addModel:1,
        };
    },
    created() {
        this.getList();
        this.getType();
    },
    methods: {
        handleSizeChange(val) {
            this.search.limit = val;
            this.searchData();
        },
        handleCurrentChange(val) {
            this.search.page = val;
            this.searchObj.page = val;
            this.getList();
        },
        searchData(){
            this.search.page = 1;
            this.searchObj = {
                ...this.search,
            }
            this.searchObj.cid = this.cid;
            this.getList();
        },
        async getList() {
            
            this.listLoading = true;
            this.$api.productlistProduct(this.searchObj).then((res) => {
                this.search.total = res.data.count;
                this.list = res.data.data.map((item) => {
                    item.label = item.label.toString();
                    item.categorys = item.categorys.toString();
                    item.image = item.img.map((img) => {
                        return this.imgProfit + img;
                    });
                    item.colorList = [];
                    item.sizeList = [];
                    item.cols = [];
                    if(item.specs.length>0){
                        item.specs.forEach(e => {
                            if(item.colorList.indexOf(e.color)<0){
                                item.colorList.push(e.color);
                            }
                            if(item.sizeList.indexOf(e.size)<0){
                                item.sizeList.push(e.size);
                            }
                        });
                    }
                    if(item.colorList.length==0){
                        colorList.push("");
                    }
                    if(item.sizeList.length==0){
                       item.sizeList.push("");
                    }
                    for(let i=0;i<item.colorList.length;i++){
                        let color = item.colorList[i];
                        let obj = {
                            name:color,
                        }
                        for(let j=0;j<item.sizeList.length;j++){
                            let size = item.sizeList[j];
                            let itemobj = this.getItem(item.specs,color,size);
                            obj[size] = itemobj;
                        }
                        item.cols.push(obj);
                    }
                    return item;
                });
                this.listLoading = false;
            });
        },
        getItem(item,color,size){
            if(item.length>0){
                for(let i in item){
                    if(item[i].color==color&&item[i].size==size){
                        item[i].count = 0;
                        item[i].num = 0;
                        return item[i];
                    }
                }
            }
            return {id:-1};
        },
        getType() {
            this.$api.productgetProdClassify().then((res) => {
                this.all = [];
                var all = {};
                all.children = res.data.data;
                all.id = 0;
                all.label = "全部";
                all.parent = -1;
                this.all.push(all);
            });
        },
        handleNodeClick(val) {
            this.search.category = val.id;
            this.search.categoryName = val.label;
            this.$refs.selectReport.blur();
        },
        selectProduct() {
            let num = this.selectData.length;
            if(num>0){
                this.$emit("close", this.selectData);
            }else{
                this.$common.error("没有添加任何产品");
            }
            
        },
        cancelRow() {
            // 取消表格行事件，不需要实现方法
        },
        clearAll:function(){
            this.tableData.specs.forEach(e => {
                e.count = 0;
                e.num = 0;
            });
            let index = this.getIndex(this.tableData.id);
            if(index>=0){
                this.selectData.splice(index,1);
            }
        },
        getIndex:function(id){
            for(let i in this.selectData){
                if(this.selectData[i].id==id){
                    return i;
                }
            }
            return -1;
        },
        openDialog:function(data,val){
            this.tableData = data;
            if(val<=2){
                this.addModel = val;
                this.specsDialog = true;
            }else if(val==3){
                this.MutiDialog = true;
            }
        },
        close:function(){
            this.MutiDialog = false;
        },
        checkSpNumber:function(){
            let index = this.getIndex(this.tableData.id);
            if(index==-1){
                this.selectData.push(this.tableData);
            }
        },
        changeEnd(e,dd,sp,val){
            sp[val] = e;
            let index = this.getIndex(dd.id);
            if(index==-1){
                this.selectData.push(dd);
            }
        },
        clearSelect:function(){
            this.selectData.forEach(e=>{
                e.specs.forEach(s=>{
                    s.num = 0;
                    s.count = 0;
                })
            })
            this.selectData = [];
        }
    },
};
</script>

<style lang="scss" scoped>
.proInfo{
    line-height: 28px;
    padding-left: 5px;
    
}
</style>
